import * as React from 'react';

const SvgNavigationMenu1 = props => {
  const { size = 24, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={size}
      width={size}
      fill={fill}
      {...props}
    >
      <g fill={fill}>
        <rect x={3} y={3} width={18} height={4} rx={1.5} />
        <rect x={3} y={10} width={18} height={4} rx={1.5} />
        <rect x={3} y={17} width={18} height={4} rx={1.5} />
      </g>
    </svg>
  );
};

export default SvgNavigationMenu1;
